import { useGraphQLMutation } from '@opengov/bnp-core';
import { useQueryClient } from '@tanstack/react-query';

import { graphql } from '../../../../../gql-generated/hasura';
import {
  DeleteNavigationMenuStoryByIdForOnlinePublicationMutation,
  DeleteNavigationMenuStoryByIdForOnlinePublicationMutationVariables
} from '../../../../../gql-generated/hasura/graphql';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { useToast } from '../../../Toast/context/useToast.context';

import { setupOnlinePublicationQueryKeys } from './setupOnlinePublicationQueryKeys';

const DeleteNavigationMenuStoryByIdForOnlinePublicationDocument = graphql(`
  mutation DeleteNavigationMenuStoryByIdForOnlinePublication($id: uuid!) {
    delete_publicationNavigationMenuStories(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`);

export type UseDeleteNavigationMenuStoryMessages = {
  successTitle: string;
  successBody?: string;
  errorTitle: string;
  errorBody?: string;
};

export type UseDeleteNavigationMenuStoryContext = {
  publicationId: string;
  menuId: string;
};

export function useDeleteNavigationMenuStory(
  context: UseDeleteNavigationMenuStoryContext,
  messages: UseDeleteNavigationMenuStoryMessages
) {
  const queryClient = useQueryClient();
  const { toggleToast } = useToast();

  return useGraphQLMutation<
    DeleteNavigationMenuStoryByIdForOnlinePublicationMutation,
    DeleteNavigationMenuStoryByIdForOnlinePublicationMutationVariables
  >({
    mutationKey: [...setupOnlinePublicationQueryKeys.all, 'deleteNavigationMenuStory', context],
    document: DeleteNavigationMenuStoryByIdForOnlinePublicationDocument,
    url: HASURA_SERVICE_URL,
    options: {
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: setupOnlinePublicationQueryKeys.menuStories({ menuId: context.menuId })
        });
        void queryClient.invalidateQueries({
          queryKey: setupOnlinePublicationQueryKeys.navigationMenus({
            publicationId: context.publicationId
          })
        });
        toggleToast({
          title: messages.successTitle,
          body: messages.successBody,
          severity: 'success'
        });
      },
      onError: () =>
        toggleToast({
          title: messages.errorTitle,
          body: messages.errorBody,
          severity: 'error'
        })
    }
  });
}
